import { useEffect, useState } from 'react';

// ID de este bundle (lo inyecta scripts/build.js). En desarrollo no existe y el
// chequeo queda desactivado.
const CURRENT_VERSION = process.env.REACT_APP_BUILD_ID;
const VERSION_URL = '/version.json';
const POLL_INTERVAL = 5 * 60 * 1000;

const CHUNK_RELOAD_KEY = 'chunk_reload_at';
const CHUNK_RELOAD_COOLDOWN = 60 * 1000;

const fetchLatestVersion = async () => {
  const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' });
  if (!response.ok) throw new Error('version.json no disponible');
  const data = await response.json();
  return data.version;
};

// Devuelve true cuando el servidor publica una versión distinta a la cargada.
// Revisa al volver a la pestaña y cada 5 min; si falla la red no avisa nada.
export const useNewVersionAvailable = () => {
  const [hasNewVersion, setHasNewVersion] = useState(false);

  useEffect(() => {
    if (!CURRENT_VERSION || hasNewVersion) return undefined;
    let cancelled = false;

    const check = async () => {
      try {
        const latest = await fetchLatestVersion();
        if (!cancelled && latest && latest !== CURRENT_VERSION) setHasNewVersion(true);
      } catch {
        // Sin red o archivo ausente: se reintenta en el próximo ciclo
      }
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };

    check();
    const intervalId = setInterval(check, POLL_INTERVAL);
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', check);
    return () => {
      cancelled = true;
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', check);
    };
  }, [hasNewVersion]);

  return hasNewVersion;
};

const isChunkError = (error) =>
  !!error && (error.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(error.message || ''));

// Red de seguridad: si una pestaña vieja intenta cargar un chunk que ya no existe
// tras un deploy, recarga una vez (con enfriamiento para no entrar en bucle).
export const installChunkErrorReload = () => {
  const reloadOnce = () => {
    try {
      const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
      if (Date.now() - last < CHUNK_RELOAD_COOLDOWN) return;
      sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    } catch {
      return;
    }
    window.location.reload();
  };

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkError(event.reason)) reloadOnce();
  });
  window.addEventListener('error', (event) => {
    if (isChunkError(event.error) || isChunkError({ message: event.message })) reloadOnce();
  });
};
